import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Latant Consulting - Complete Digital Solutions',
  description = 'Expert consulting in Stencil.js, React, Node.js, Angular, Flutter, Ruby on Rails & Python. We specialize in framework-agnostic web components and full-stack digital transformation.',
  keywords = 'Stencil.js consulting, web components, React development, Angular consulting, Node.js services, Flutter development, Ruby on Rails, Python development, digital transformation, full-stack consulting, framework-agnostic components',
  image = 'https://latantconsulting.com/logo512.png',
  url = 'https://latantconsulting.com',
  type = 'website'
}) => {
  const siteTitle = title.includes('Latant') ? title : `${title} | Latant Consulting`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Latant Consulting" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Latant Consulting" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO Tags */}
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
    </Helmet>
  );
};

export default SEO;
